import { render, staticRenderFns } from "./AffiliateReport.vue?vue&type=template&id=144e273c&scoped=true&"
import script from "./AffiliateReport.vue?vue&type=script&lang=js&"
export * from "./AffiliateReport.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateReport.vue?vue&type=style&index=0&id=144e273c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144e273c",
  null
  
)

export default component.exports